import { Theme, useTheme } from '@mui/material'
import { Components } from '@mui/material/styles/components'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { Check, Minus } from 'lucide-react'
import { FC } from 'react'

const UncheckedIcon: FC = () => {
    const theme = useTheme()
    return (
        <svg viewBox="0 0 26 26">
            <rect
                x="1"
                y="1"
                width="24"
                height="24"
                rx="4"
                fill={theme.palette.background.paper}
                stroke={theme.palette.grey[300]}
                strokeWidth="1.25"
            />
        </svg>
    )
}

const CheckedIcon: FC = () => {
    const theme = useTheme()
    return (
        <svg viewBox="0 0 26 26">
            <rect
                x="1"
                y="1"
                width="24"
                height="24"
                rx="4"
                fill={theme.palette.primary.main}
            />
            <Check
                x="4"
                y="4"
                width="18"
                height="18"
                color={theme.palette.common.white}
                strokeWidth="2.5"
            />
        </svg>
    )
}

const IndeterminateIcon: FC = () => {
    const theme = useTheme()
    return (
        <svg viewBox="0 0 26 26">
            <rect
                x="1"
                y="1"
                width="24"
                height="24"
                rx="4"
                fill={theme.palette.primary.main}
            />
            <Minus
                x="4"
                y="4"
                width="18"
                height="18"
                color={theme.palette.common.white}
                strokeWidth="2.5"
            />
        </svg>
    )
}

export const C1CheckboxTheme: Components<Theme>['MuiCheckbox'] = {
    defaultProps: {
        icon: <UncheckedIcon />,
        checkedIcon: <CheckedIcon />,
        indeterminateIcon: <IndeterminateIcon />,
    },
    styleOverrides: {
        root: ({ theme }) =>
            theme.unstable_sx({
                marginX: 1,
                borderRadius: C1BorderRadius.large,
                width: '36px',
                height: '36px',
                svg: {
                    width: '18px',
                    height: '18px',
                },
                '&:hover': {
                    backgroundColor: 'primary.extraLight',
                },
                '&:not(.Mui-checked):hover svg rect': {
                    stroke: theme.palette.primary.dark,
                    fill: 'none',
                },
                '&.Mui-focusVisible': {
                    outline: `2px solid ${theme.palette.primary.main}`,
                    outlineOffset: '1px',
                    backgroundColor: 'primary.extraLight',
                },
                '&.Mui-focusVisible svg rect': {
                    stroke: theme.palette.primary.dark,
                },
                '&.Mui-disabled': {
                    cursor: 'not-allowed',
                },
                '&.Mui-disabled svg rect': {
                    fill: theme.palette.grey[200],
                    stroke: 'transparent',
                },
                '&.Mui-disabled.Mui-checked svg rect': {
                    fill: theme.palette.grey[200],
                },
                '&.Mui-disabled.Mui-checked svg .lucide': {
                    color: theme.palette.grey[400],
                },
            }),
        sizeSmall: {
            width: 18,
            height: 18,
            padding: 0,
            marginRight: '6px',
        },
    },
}
